import { useApi } from '@hooks/useApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { queryKeys } from '@utils/consts';
import { isFailure } from './create';
import { AcquirerUser } from '@root/globalTypes';

export function useDisableUser({ acquirerId }: { acquirerId: string }) {
  const { query } = useApi();
  const queryClient = useQueryClient();
  const [apiError, setApiError] = useState<string>('');

  const { mutate, isPending } = useMutation({
    mutationFn: (id: string): Promise<AcquirerUser> => {
      return query({
        path: `v1/staff/acquirers/${acquirerId}/users/${id}/disable`,
        opt: {
          method: 'PUT',
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      if (isFailure(data)) setApiError(data.message);
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: [...queryKeys.acquirerUsers, acquirerId] });
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
}
